import * as CONSTANTS from '../actions/constantsSocialActions';

const initialState = {
  searches: null,
  shorSearches: null,
};

export default function social(state = initialState, action) {
  switch (action.type) {
    case CONSTANTS.SET_SEARCHES:
      return Object.assign({}, state, { searches: action.socialSearches });
    case CONSTANTS.ADD_SEARCHES:
      return Object.assign({}, state, {
        searches: [...state.searches, ...action.socialSearches],
      });
    case CONSTANTS.UPDATE_USER_IN_SEARCH_LIST:
      // eslint-disable-next-line no-case-declarations
      const searchListUpdated = [
        ...state.searches.slice(0, action.index),
        action.userUpdated,
        ...state.searches.slice(action.index + 1),
      ];
      return Object.assign({}, state, { searches: searchListUpdated });
    case CONSTANTS.CLEAR_SEARCHES:
      return Object.assign({}, state, { searches: null });
    default:
      return state;
  }
}
